import {
  ListLessonPlanFilters,
  listLessonPlans,
} from '@/data/services/lessonPlanServices';

export const lessonPlanQueries = {
  all: ['lessonPlans'] as const,

  list: (filters: ListLessonPlanFilters = {}) => ({
    queryKey: [...lessonPlanQueries.all, 'list', { filters }] as const,
    queryFn: () => listLessonPlans({ ...filters }),
  }),
};
